function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 64a1.5 1.5 0 01-1.06-2.56l61-61a1.5 1.5 0 012.12 2.12l-61 61A1.5 1.5 0 011.5 64z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.5 64a1.5 1.5 0 01-1.06-.44l-61-61A1.5 1.5 0 012.56.44l61 61A1.5 1.5 0 0162.5 64z"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default SvgClose;